import { render, staticRenderFns } from "./PublicSettings.vue?vue&type=template&id=39db44ad&scoped=true&"
import script from "./PublicSettings.vue?vue&type=script&lang=js&"
export * from "./PublicSettings.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/forms.css?vue&type=style&index=0&id=39db44ad&scoped=true&lang=css&"
import style1 from "./PublicSettings.vue?vue&type=style&index=1&id=39db44ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db44ad",
  null
  
)

export default component.exports